import { Box } from '@mui/material';
import type { CaseStudyContentDynamicZone } from '@rumblefish/strapi/strapiTypes';
import { Contact, Layout } from '@rumblefish/ui/Rumblefish23Theme';
import { useState } from 'react';
import { NextHeadWithMeta } from '../NextHeadWithMeta';
import { AdditionalInfo } from './AdditionalInfo/AdditionalInfo';
import { AdditionalData } from './CaseStudy.data';
import { metaData } from './CaseStudy.seo';
import type { CaseStudyProps } from './CaseStudy.types';
import { Content } from './Content/Content';
import { Hero } from './Hero/Hero';

export const CaseStudyView = ({
  blogPosts,
  caseStudy,
  otherCaseStudies,
}: CaseStudyProps) => {
  const [isPasswordVerified, setIsPasswordVerified] = useState(false);
  const [userPassword, setUserPassword] = useState('');

  const { additionalInfoProps } = new AdditionalData(
    caseStudy,
    otherCaseStudies
  );

  if (caseStudy.previewPassword && !isPasswordVerified) {
    return (
      <Box sx={{ width: '100%', padding: '2rem', textAlign: 'center' }}>
        <h2>This case study is in the preview stage.</h2>
        <p>Please enter the password to view the content:</p>
        <form>
          <input
            type="password"
            placeholder="Enter password"
            onChange={(e) => {
              setUserPassword(e.target.value);
            }}
          />
          <button
            onClick={(e) => {
              e.preventDefault();
              if (userPassword === caseStudy.previewPassword) {
                setIsPasswordVerified(true);
                alert('Password verified! You can now view the case study.');
              } else {
                alert('Incorrect password. Please try again.');
              }
            }}>
            Submit
          </button>
        </form>
      </Box>
    );
  }

  return (
    <Layout blogPosts={blogPosts}>
      <NextHeadWithMeta
        {...metaData(
          caseStudy?.metaTitle || caseStudy?.title || '',
          caseStudy?.metaDescription || caseStudy?.cardDescription || ''
        )}
      />
      <Hero
        title={caseStudy?.title}
        subtitle={caseStudy?.subtitle}
        client={caseStudy?.client}
        image={caseStudy?.image?.url}
        mobileImage={caseStudy?.mobileImage?.url}
        heroBackgroundImage={caseStudy?.homePageFirstImg?.url}
        slug={caseStudy?.slug}
        useMockupImage={caseStudy?.useMockupImage || false}
      />
      <Content
        components={caseStudy?.content as CaseStudyContentDynamicZone[]}
        caseStudy={caseStudy}
      />
      {additionalInfoProps && <AdditionalInfo {...additionalInfoProps} />}
      <Contact />
    </Layout>
  );
};
